import { UserDirectorySlideout } from '../../../../ui/features/user-directory/components/UserDirectorySlideout';
import { useUserDirectoryTable } from '../../../../ui/features/user-directory/hooks/useUserDirectoryTable';
import { useContactManagementTranslation } from '../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import { Box } from '@mui/material';
import React from 'react';
export const UserDirectoryPanel = ({ ariaSlideoutContentId }) => {
    const { t } = useContactManagementTranslation();
    const { dataTableProps, clearActiveRow, reload } = useUserDirectoryTable({
        onRowClick: () => undefined,
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeaderWithImage, { gradient: 'blue-base', title: t('panels.userDirectory.title') }),
        React.createElement(Box, { p: 4 },
            React.createElement(DataTable, Object.assign({}, dataTableProps))),
        React.createElement(UserDirectorySlideout, { accountId: dataTableProps.activeRowId, onClose: (changed) => {
                clearActiveRow();
                if (changed) {
                    reload();
                }
            }, ariaSlideoutContentId: ariaSlideoutContentId })));
};
